import React from 'react';
import { withTranslation } from "react-i18next";

class Dialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: props.isOpen || false
    };
  }

  componentDidUpdate(prevProps) {
    // Update state when props change
    if (prevProps.isOpen !== this.props.isOpen) {
      this.setState({ isOpen: this.props.isOpen });
    }
  }

  openDialog = () => {
    this.setState({ isOpen: true });
    if (this.props.onOpen) {
      this.props.onOpen();
    }
  };

  closeDialog = () => {
    this.setState({ isOpen: false });
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  render() {
    const { t } = this.props;
    const { isOpen } = this.state;
    const { title, children } = this.props;

    if (!isOpen) return null;

    return (
      <div className="dialog-overlay">
        <div className="dialog-content">
          <div className="dialog-header d-flex justify-content-center align-items-center">
            <p className="text-blod-description font-bold text-color-black text-center-important">{title}</p>
          </div>
          <div className="dialog-body">
            {children}
          </div>
          <div className="dialog-footer">
            <button className="btn-default custom" onClick={this.closeDialog}>{t("Close")}</button>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(Dialog);